import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export class BookingToPair {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  recordLocator!: string;
  @IsString()
  @Expose()
  contractorName!: string;
  @IsString()
  @Expose()
  createdAt!: string;
  @IsNumber()
  @Expose()
  amount!: number;
}
